import { useState, useEffect } from 'react';
import axios from 'axios';

const BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
const API_URL = `${BASE_URL}/api`;

export const useSiteSettings = () => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API_URL}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const getSetting = (key, defaultValue = '') => {
    const v = settings?.[key];
    return (v === undefined || v === null || v === '') ? defaultValue : v;
  };

  return { settings, loading, getSetting, refetch: fetchSettings };
};
